
var anchorBtns = document.querySelectorAll('.anchor-btn');

anchorBtns.forEach(function(btn) {
  btn.addEventListener('click', function(e) {

    var target = e.target as HTMLDivElement;

    var scrollItem = "";
    if(target.dataset.anchor != undefined){
      scrollItem = '.' + target.dataset.anchor;
    }
    else {
      scrollItem = '.' + target.parentElement.dataset.anchor;
    }
    var scrollElement = document.querySelector(scrollItem);

    scrollIntoViewIfNeeded(scrollElement, 'start');
  });
});
function scrollIntoViewIfNeeded(target: any, position: string) {
  if(target != null){
    if (target.getBoundingClientRect().bottom > window.innerHeight) {
      target.scrollIntoView({
          behavior: "smooth",
          block: position
      });
  }
  }
    
}